export default function () {
  return (-this.snapGrid[0]);
}



// WEBPACK FOOTER //
// ../src/components/core/translate/minTranslate.js